// Tempo real: quando outra pessoa (ou outro computador) muda algo no salão, esta tela se atualiza sozinha.
// O servidor só avisa "mudou"; aqui as consultas abertas buscam os dados de novo.
import { useEffect } from 'react';
import { CLIENT_ID } from '../api.ts';
import { queryClient } from './data.ts';

export function useLiveSync() {
  useEffect(() => {
    if (typeof EventSource === 'undefined') return;
    let timer: number | undefined;
    let opened = false;
    const refresh = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => void queryClient.invalidateQueries(), 150);
    };
    // o navegador reconecta sozinho; ao voltar, busca o que passou enquanto esteve fora
    const es = new EventSource('/api/events');
    es.onmessage = (e) => {
      try { if ((JSON.parse(e.data) as { src?: string | null }).src === CLIENT_ID) return; } catch { /* aviso sem dados: atualiza */ }
      refresh();
    };
    es.onopen = () => { if (opened) refresh(); opened = true; };
    const visible = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', visible);
    return () => { window.clearTimeout(timer); es.close(); document.removeEventListener('visibilitychange', visible); };
  }, []);
}
